import withRouter from '@utils/wrappers/WithRouter';
import CrudPage from '@modules/cruds/CrudPage';
import LicenseForm from './LicenseForm';
import * as yup from 'yup'; // for everything
import { useAppSelector } from '@redux/store';
import { IConfigComponent } from '@ts/ui-models';
import { generateConfigComponent } from '@modules/dataGrid/GlobalDataGrid';

const licenseSchema = yup.object().shape({
  ownerOrganizationId: yup.string().required().label('Organization'),
  licenseTypeLid: yup.string().required().label('License type'),
  licenseValidStart: yup.date().required().label('License valid start'),
  licenseValidEnd: yup.date().required().label('License valid end'),
});

const LicensePage = props => {
  const itemId = props.transferPropsRoute.params.id;
  const user = useAppSelector(state => state.global.user);

  const { role } = user || {};

  const defaultValues = {
    licenseValidStart: new Date(),
    //@ts-ignore
    ownerOrganizationId: role?.ownerOrganizationId,
    //@ts-ignore
    organization: role?.organization.logicalId,
  };

  const config: IConfigComponent = generateConfigComponent('license');

  return (
    <CrudPage
      key={itemId}
      configComponent={config}
      form={LicenseForm}
      defaultValues={defaultValues}
      validationSchema={licenseSchema}
    />
  );
};

export default withRouter(LicensePage);
